import 'antd/lib/table/style';
import 'antd/lib/icon/style';
import 'antd/lib/popconfirm/style';
import 'antd/lib/tooltip/style';
import 'antd/lib/checkbox/style';
import 'antd/lib/popover/style';

import '../VortexDatagrid.less';